import { render, staticRenderFns } from "./TalkRule.vue?vue&type=template&id=15a99416&scoped=true&"
import script from "./TalkRule.vue?vue&type=script&lang=js&"
export * from "./TalkRule.vue?vue&type=script&lang=js&"
import style0 from "./TalkRule.vue?vue&type=style&index=0&id=15a99416&prod&lang=scss&scoped=true&"
import style1 from "./TalkRule.vue?vue&type=style&index=1&id=15a99416&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a99416",
  null
  
)

export default component.exports